module.exports = __webpack_public_path__ + "chrono-diali-favicon.png";